import { render, staticRenderFns } from "./assets-table.vue?vue&type=template&id=cc74e900&scoped=true&"
import script from "./assets-table.vue?vue&type=script&lang=js&"
export * from "./assets-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc74e900",
  null
  
)

export default component.exports